import { gql } from '@apollo/client'

export const GENERATE_PUBLIC_TOKEN = gql`
  mutation generatePublicToken(
    $leadSourceId: Int!
    $stagePipelineId: Int!
    $campusId: Int
    $stagePipelineIntentId: Int
    $stagePipelineSignedId: Int
    $stagePipelineQuotedId: Int
    $agentId: Int
    $signatureFormEsId: Int
    $signatureFormEnId: Int
    $sendEmail: Boolean
    $sendSms: Boolean
    $requireIdentity: Boolean
    $sourceDescription: String
  ) {
    generatePublicToken(
      leadSourceId: $leadSourceId,
      stagePipelineId: $stagePipelineId,
      campusId: $campusId
      stagePipelineIntentId: $stagePipelineIntentId
      stagePipelineSignedId: $stagePipelineSignedId
      stagePipelineQuotedId: $stagePipelineQuotedId
      agentId: $agentId
      signatureFormEsId: $signatureFormEsId
      signatureFormEnId: $signatureFormEnId
      sendEmail: $sendEmail
      sendSms: $sendSms
      requireIdentity: $requireIdentity
      sourceDescription: $sourceDescription
    ) {
      success
      token
      errors {
        field
        message
      }
    }
  }
`
